import { Plus, Trash2 } from "lucide-react";

interface CreateRequestUrlListProps {
  urls: string[];
  urlErrors: (string | null)[];
  canAdd: boolean;
  onChange: (index: number, value: string) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
}

export const CreateRequestUrlList = ({
  urls,
  urlErrors,
  canAdd,
  onChange,
  onAdd,
  onRemove,
}: CreateRequestUrlListProps) => (
  <div className="create-request-modal-url-list">
    <div className="create-request-modal-url-list-head">
      <label className="create-request-modal-label">Адрес сайта</label>
      <button
        type="button"
        className="create-request-modal-url-add-btn"
        onClick={onAdd}
        disabled={!canAdd}
        aria-label="Добавить адрес сайта"
      >
        <Plus size={18} />
      </button>
    </div>
    {urls.map((url, index) => (
      <div key={`url-${index}`} className="create-request-modal-url-row">
        <div className="create-request-modal-form-group">
          <input
            type="text"
            className={`create-request-modal-input${urlErrors[index] ? " create-request-modal-input--error" : ""}`}
            placeholder="https://example.com"
            value={url}
            onChange={(e) => onChange(index, e.target.value)}
          />
          {urlErrors[index] && (
            <span className="create-request-modal-field-error">{urlErrors[index]}</span>
          )}
        </div>
        {urls.length > 1 && (
          <button
            type="button"
            className="create-request-modal-url-remove-btn"
            onClick={() => onRemove(index)}
            aria-label="Удалить адрес сайта"
          >
            <Trash2 size={18} />
          </button>
        )}
      </div>
    ))}
  </div>
);
